import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

// 分页查询表单模板列表
export const reqFormTemplateList = params => { return axios({method:'post',url:`${base}/formtemplate/formtemplatelist`,params:params}).then(res=>res.data); }

// 新增/编辑表单模板
export const reqFormTemplateEdit = params => { return axios({method:'post',url:`${base}/formtemplate/formtemplateedit`,params:params}).then(res=>res.data); }

// 删除表单模板
export const reqFormTemplateDelete = params => { return axios({method:'post',url:`${base}/formtemplate/formtemplatedelete`,params:params}).then(res=>res.data); }

// 获取单个表单模板详情
export const reqFormTemplateInfo = params => { return axios({method:'post',url:`${base}/formtemplate/formtemplateinfo`,params:params}).then(res=>res.data); }

// 获取某模板的所有流程步骤
export const reqFormTemplateStepList = params => { return axios({method:'post',url:`${base}/formtemplate/formtemplatesteplist`,params:params}).then(res=>res.data); }

// 导出所有表单模板为 Excel（每个模板一个 sheet）
export const reqFormTemplateExport = params => { return axios({method:'post',url:`${base}/formtemplate/export`,params:params}).then(res=>res.data); }

// 新增/编辑单个流程步骤
export const reqFormTemplateStepEdit = params => { return axios({method:'post',url:`${base}/formtemplate/formtemplatestepedit`,params:params}).then(res=>res.data); }

// 删除单个流程步骤
export const reqFormTemplateStepDelete = params => { return axios({method:'post',url:`${base}/formtemplate/formtemplatestepdelete`,params:params}).then(res=>res.data); }
